import duneAwakening from "./duneAwakening";
import { type GameProfile, type ProfileCtx } from "./types";

// TR-5418: the console profile no longer differs from the PC one.
//
// It used to add the Server Custom Settings sections that `duneAwakening.ts` withheld while the
// delivery was gated to console. Those now sit in `baseConfigSections`, so re-listing them here
// would render each section twice.
//
// The module stays because `index.ts` is keyed on the profile class name and the console rows
// resolve to `DuneAwakeningConsole` — dropping it would fall them back to the default profile,
// not to this one. See the matching note on the Python class.
export default (_ctx: ProfileCtx): Partial<GameProfile> => duneAwakening(_ctx);
